import { render, staticRenderFns } from "./MaterialEditPage.vue?vue&type=template&id=5dc0c797&scoped=true"
import script from "./MaterialEditPage.vue?vue&type=script&lang=ts"
export * from "./MaterialEditPage.vue?vue&type=script&lang=ts"
import style0 from "./MaterialEditPage.vue?vue&type=style&index=0&id=5dc0c797&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc0c797",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dc0c797')) {
      api.createRecord('5dc0c797', component.options)
    } else {
      api.reload('5dc0c797', component.options)
    }
    module.hot.accept("./MaterialEditPage.vue?vue&type=template&id=5dc0c797&scoped=true", function () {
      api.rerender('5dc0c797', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/MaterialEditPage.vue"
export default component.exports